module.exports = __webpack_public_path__ + "img/gear-pegboard.13314319.svg";